export default "__VITE_ASSET__033f35b0__"